<div class="container">

    <section class='header'>

        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div>
                <mat-icon style='margin-top:10px; font-size:.9em;'>store_mall_directory</mat-icon>
                <div style='display:inline-block; margin-left:10px;'>
                    {{ local_title }}
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar>

    </section>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>store_mall_directory</mat-icon>
                    <div>Sala</div>
                </ng-template>

                <div class='tab-content-id'>

                    <mat-form-field class="full-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.name" placeholder="Nome" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                            O nome é obrigatório
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="full-width">
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.location" placeholder="Localização" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.location.hasError('required')">
                            A localização é obrigatória.
                        </mat-error>
                    </mat-form-field>

                </div>

            </mat-tab>

        </mat-tab-group>

    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
    </div>

</div>